import {inject, Injectable} from '@angular/core';

import {ACCESS_TOKEN} from "@numizmat/constants";
import {environment} from "@numizmat/environments";
import {CookieService} from "@numizmat/services/common";

@Injectable({
  providedIn: 'root'
})
export class AccessTokenService {
  private cookieService: CookieService = inject(CookieService);
  private developmentAccessToken: string = 'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJ1c2VyLWlkIjoiN2M0MTcyYmEtNWQ4Ni00ZTZlLWE1NzEtNDI4NTM2NTBhZjQzIiwibmJmIjoxNzQ4MTUzNjE1LCJleHAiOjE3NDg3NTg0MTUsImlhdCI6MTc0ODE1MzYxNX0.rNTi3PN32iAtRohpEDYONF8hIbJ3kkgI2IRSBndNPUtx_FR9AZVtShK5zVi-2VhZm8zAQOm_n8BK1qBVM57TGQ';

  public getAccessToken(): string | null {
    if (environment.production) {
      return this.cookieService.getCookie(ACCESS_TOKEN);
    } else {
      return this.developmentAccessToken;
    }
  }

  public setAccessToken(accessToken: string): void {
    this.cookieService.setCookie(ACCESS_TOKEN, accessToken);
    if (!environment.production) {
      this.developmentAccessToken = accessToken;
    }
  }

  public deleteAccessToken(): void {
    this.cookieService.deleteCookie(ACCESS_TOKEN);
    if (!environment.production) {
      this.developmentAccessToken = '';
    }
  }
}
